/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { clearLocalStorage } from '../utils';

function withClearCache(Component: any) {
  function ClearCacheComponent(props: JSX.IntrinsicAttributes) {
    const [isLatestBuildDate, setIsLatestBuildDate] = useState(false);

    useEffect(() => {
      fetch('/meta.json')
        .then((response) => response.json())
        .then((meta) => {
          const buildDate: string | null = localStorage.getItem('buildDate');
          const latestVersionDate = meta.buildDate;
          if (!buildDate || buildDate !== latestVersionDate.toString()) {
            clearLocalStorage();
            localStorage.setItem('buildDate', latestVersionDate ?? '');
            window.location.reload();
            setIsLatestBuildDate(false);
          } else {
            setIsLatestBuildDate(true);
          }
          // if (!buildDate || buildDate !== latestVersionDate) {
          //   localStorage.clear();
          //   // delete browser cache and hard reload
          //   window.location.reload();
          //   setIsLatestBuildDate(false);
          // }

          // const shouldForceRefresh = buildDateGreaterThan(latestVersionDate, currentVersionDate);

          // if (shouldForceRefresh) {
          //   setIsLatestBuildDate(false);
          //   refreshCacheAndReload();
          // } else {
          //   setIsLatestBuildDate(true);
          // }
        });
    }, []);

    return isLatestBuildDate ? <Component {...props} /> : null;
  }

  return ClearCacheComponent;
}

export default withClearCache;
